import React from 'react';
import { Box, Button, IconButton, ToggleButton, ToggleButtonGroup } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AddIcon from '@mui/icons-material/Add';
import './UserCalendar.css';

const CALENDAR_VIEWS = [
  { value: 'dayGridWeek', label: 'Woche' },
  { value: 'dayGridMonth', label: 'Monat' },
  { value: 'multiMonthYear', label: 'Jahr' },
];

interface UserCalendarHeaderProps {
  title: string;
  currentView: string;
  userData: any;
  isAddDisabled: boolean;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
  onViewChange: (view: string) => void;
  onAddAbsence: () => void;
}

const UserCalendarHeader: React.FC<UserCalendarHeaderProps> = ({
  title,
  currentView,
  userData,
  isAddDisabled,
  onPrev,
  onNext,
  onToday,
  onViewChange,
  onAddAbsence,
}) => {
  const handleViewChange = (_: React.MouseEvent<HTMLElement>, view: string | null) => {
    if (view) {
      onViewChange(view);
    }
  };

  return (
    <Box className="user-calendar-header">
      <Box className="user-calendar-header-group">
        <IconButton onClick={onPrev} size="small" aria-label="Zurück">
          <ChevronLeftIcon />
        </IconButton>
        <IconButton onClick={onNext} size="small" aria-label="Weiter">
          <ChevronRightIcon />
        </IconButton>
        <Button onClick={onToday} variant="outlined" size="small">
          Heute
        </Button>
        <span className="user-calendar-title">{title}</span>
      </Box>

      <Box className="user-calendar-header-group">
        <span className="user-calendar-user">
          {userData.firstName} {userData.lastName} ({userData.nickName})
        </span>
      </Box>

      <Box className="user-calendar-header-group">
        <Button onClick={onAddAbsence} startIcon={<AddIcon />} disabled={isAddDisabled}>
          Abwesenheit hinzufügen
        </Button>
        <ToggleButtonGroup value={currentView} exclusive onChange={handleViewChange} size="small">
          {CALENDAR_VIEWS.map((view) => (
            <ToggleButton key={view.value} value={view.value}>
              {view.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};

export default UserCalendarHeader;
